import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nl from './nl.json';
import de from './de.json';
import en from './en.json';
import fr from './fr.json';

// Detect locale from WordPress config or URL
const config = window.astConfig || {};
const urlParams = new URLSearchParams(window.location.search);
const detectedLang = urlParams.get('lang')
    || config.locale
    || localStorage.getItem('ast_locale')
    || navigator.language?.substring(0, 2)
    || 'nl';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            nl: { translation: nl },
            de: { translation: de },
            en: { translation: en },
            fr: { translation: fr },
        },
        lng: detectedLang,
        fallbackLng: 'nl',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
